var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgNoNft = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 190,
    height: 190,
    viewBox: "0 0 190 190",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 189,
    height: 189,
    rx: 8.5,
    fill: "#110E09",
    stroke: "#2B2A28"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m93.957 58 43.98 25.05v25.05l-43.98-25.05V58Z",
    fill: "#272522",
    stroke: "#110E09",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m93.957 132.963 43.98-24.797V83.369l-43.98 24.797v24.797ZM93.957 58 51.062 83.05v25.05l42.895-25.05V58Z",
    fill: "#272522",
    stroke: "#110E09",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m93.957 132.963-42.895-24.797V83.369l42.895 24.797v24.797Z",
    fill: "#272522",
    stroke: "#110E09",
    strokeWidth: 2
  })));
};
export default SvgNoNft;